import { useInfiniteQuery } from '@tanstack/react-query'
import { useXMPPClientContext } from '../xmpp-client/XMPPClientContext'

export const useConversationRoomLoader = (
  conversationId: string,
  isCurrentUserMember: boolean,
  isEnabled: boolean
) => {
  const { client, publicClient } = useXMPPClientContext()

  return useInfiniteQuery({
    queryKey: ['conversation-room-loader', conversationId, isCurrentUserMember],
    queryFn: async ({ pageParam }) => {
      const clientToUse = isCurrentUserMember ? client : publicClient
      return clientToUse.loadRoomEvents(conversationId, {
        before: pageParam,
        waitForRoomPreparation: true,
      })
    },
    getNextPageParam: lastPage => {
      return lastPage[0]?.paginationId ?? null
    },
    initialPageParam: undefined as string | undefined,
    enabled: isEnabled,
    refetchOnWindowFocus: false,
  })
}
